import React from 'react'
import Images from "../../../../config/Images";
import "./SignInNavBar.css"
import {useDispatch} from "react-redux";
import {updateSignUpScreen} from "store/ui/signUpScreen/signUpScreen.slice";
import {RedTextBold} from "components/text/Text";

function SignInNavBar() {
  const dispatch = useDispatch();
  return (
    <div className={'sign-in-nav'}>
      <img src={Images.benevvLogo} alt={"Benevv Logo"} className={"sign-in-nav-bar-benevv-logo"}
           onClick={() => dispatch(updateSignUpScreen(''))}/>
      <div className={'sign-in-nav-text'}>
        <p className={'already-have-an-account'}> Already have an account?&nbsp;</p>
        <RedTextBold onClick={() => dispatch(updateSignUpScreen('SignInScreen'))}>
          Sign In
        </RedTextBold>
      </div>
    </div>
  )
}

export default SignInNavBar;
